import { useMemo } from 'react';

import { Config } from '@modules/common/types/config';
import { getConfig } from '@modules/common/helpers/config';

export const useConfig = (): Config =>
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useMemo(() => getConfig(), []);
